import React, { useEffect, useState } from 'react';
import { View, StyleSheet } from "react-native";
import { Calendar, DateData } from 'react-native-calendars';
import dayjs from 'dayjs';
import { useRouter } from 'expo-router';
import { usePersistBoundStore } from '@/services/zustand/Store';
import { MarkedDates } from '@/services/Datatypes';

const INITIAL_DATE = dayjs().format('YYYY-MM-DD');

export default function DatePicker() {
    const router = useRouter();
    const getAllStoredEpapers = usePersistBoundStore((state) => state.getAllStoredEpapers);
    const updateSelectedDate = usePersistBoundStore((state) => state.updateSelectedDate);
    const [markedDates, setMarkedDates] = useState<MarkedDates>({});
    const epapers = getAllStoredEpapers();

    const handleLinkPress = (date: DateData) => {
        //console.log("Datepicker.tsx - handleLinkPress")
        if (date?.dateString) {
            const formattedDate = dayjs(date.dateString).format('YYYYMMDD').toString();
            updateSelectedDate(formattedDate);
            router.back();
        }
    };

    useEffect(() => {
        let newMarkedDates: MarkedDates = {};

        epapers.forEach(epaper => {
            const date = dayjs(epaper.date, 'YYYYMMDD').format('YYYY-MM-DD');
            newMarkedDates[date] = { selected: false, marked: true, dotColor: 'green' };
        });
        setMarkedDates({ ...markedDates, ...newMarkedDates });
    }, []);

    return (
        <View>
            <Calendar
                enableSwipeMonths
                current={INITIAL_DATE}
                style={styles.calendar}
                onDayPress={handleLinkPress}
                onDayHover={() => console.log('onDayHover')}
                markedDates={markedDates}
            />
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#F5FCFF',
    },
    dayContainer: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    customText: {
        fontSize: 12,
        color: 'gray',
    },
    text: {
        textAlign: 'center',
        padding: 10,
        backgroundColor: 'lightgrey',
        fontSize: 16
    },
    calendar: {
        marginBottom: 10
    },
});
